import { render, staticRenderFns } from "./CartPositionCustomerReferenceInput.vue?vue&type=template&id=0efb3434&scoped=true"
import script from "./CartPositionCustomerReferenceInput.vue?vue&type=script&lang=ts"
export * from "./CartPositionCustomerReferenceInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb3434",
  null
  
)

export default component.exports